export default __webpack_public_path__ + "static/media/circle-blue.bf766b10.svg";